export default __webpack_public_path__ + "media/images/Masto-E1-Punk-Duck-85a4ca8bf57cfda4ea7eaf205b989f0a.png";